//配置全局访问接口地址
let commonUrl = "https://1777my.com/";


let baseUrl = {
    commonUrl
}

export default baseUrl